var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({class:[{ '--active': _vm.isActive }, 'v-link'],attrs:{"href":_vm.pagePath}},
    _vm.withAccessChecks
      ? _vm.isPurchaseRequired
        ? { click: _vm.triggerCheckout }
        : _vm.isPresent(_vm.availableAfter)
        ? { click: _vm.triggerScheduledModal }
        : { click: _vm.handleClick }
      : { click: _vm.handleClick }
  ),[(_vm.withAccessChecks)?[_vm._t("default",null,{"isLoadingAccess":_vm.forceLock ? false : _vm.isLoadingAccess,"isLocked":_vm.forceLock || _vm.isLocked,"availableAfter":_vm.availableAfter})]:[_vm._t("default",null,{"isLoadingAccess":false,"isLocked":false,"availableAfter":null})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }